import { cloneDeep } from 'lodash';

/* @ts-ignore  */
import { ApartmentsList, MediaItem } from 'features/ApartmentList/types';

export const getUpdatedData = (data: ApartmentsList[], placement: number, media: MediaItem[]) => {
  const clonedData = cloneDeep(data);
  const hasMedia = media.length > 0;
  /* @ts-ignore  */
  clonedData.forEach(({ placements }) => {
    /* @ts-ignore  */
    const index = placements.findIndex(({ placementId }) => placementId === placement);

    if (index >= 0) {
      const editedPlacement = { ...placements[index], hasMedia: hasMedia };
      placements.splice(index, 1, editedPlacement);
    }
  });

  return clonedData;
};
